import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, Button } from "reactstrap"

import { connect } from "react-redux"
import { toast } from "react-toastify"
import ModalFornecedores from "./FornecedoresModal"

const Fornecedores = props => {
  document.title = "Fornecedores | Seu Dashboard"

  const [modal, setModal] = useState(false)
  const [fornecedorEditavel, setFornecedorEditavel] = useState(null)

  const [data, setData] = useState({
    columns: [
      {
        label: "ID",
        field: "id",
        sort: "asc",
        width: 150,
      },
      {
        label: "Nome",
        field: "nome",
        sort: "asc",
        width: 200,
      },
      {
        label: "Endereço",
        field: "endereco",
        sort: "asc",
        width: 250,
      },
      {
        label: "Telefone",
        field: "telefone",
        sort: "asc",
        width: 200,
      },
      {
        label: "CPF/CNPJ",
        field: "cpf_cnpj",
        sort: "asc",
        width: 200,
      },
      {
        label: "Responsável",
        field: "responsavel",
        sort: "asc",
        width: 200,
      },
    ],
    rows: [],
  })

  const getFornecedores = () => {
    fetch(`${process.env.REACT_APP_API}/fornecedores`)
      .then(response => response.json())
      .then(response => {
        setData(data => ({
          ...data,
          rows: response.map(fornecedor => ({
            id: fornecedor.FornecedorID,
            nome: fornecedor.Nome,
            endereco: fornecedor.Endereco,
            telefone: fornecedor.Telefone,
            cpf_cnpj: fornecedor.CPF_CNPJ,
            responsavel: fornecedor.Responsavel,
            clickEvent: () => {
              setFornecedorEditavel(fornecedor)
              setModal(true)
            },
          })),
        }))
      })
  }

  useEffect(() => {
    getFornecedores()
  }, [])

  const toggleModal = () => setModal(!modal)

  const handleAdd = () => {
    //setFornecedorEditavel(null)
    toggleModal()
  }

  const handleOnEdicao = (texto, type) => {
    if (type === "success") {
      toast.success(texto)
    } else {
      toast.error(texto)
    }
    getFornecedores()
  }

  return (
    <React.Fragment>
      <ModalFornecedores
        isOpen={modal}
        toggle={toggleModal}
        FornecedorEditavel={fornecedorEditavel}
        onFornecedorAlterado={handleOnEdicao}
      />
      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <Button color="primary" onClick={handleAdd}>
                Adicionar Fornecedor
              </Button>
              <MDBDataTable striped responsive bordered data={data} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default connect(null, {})(Fornecedores)
